import { useCenterStore } from "../store/center.store";
import Pinia from "../pinia";

//m�thode 1 : par store
export default function () {
  navigator.serviceWorker.addEventListener("message", async (event) => {
    if (event.data.meta === "workbox-broadcast-update") {
      const { cacheName, updatedURL } = event.data.payload;
      if (cacheName === "cache-api-centres") {
        const cache = await caches.open(cacheName);
        const keys = await cache.keys();
        const cachedRequest = keys.find(({ url }) => url === updatedURL);
        if (cachedRequest) {
          const updatedResponse = await cache.match(cachedRequest);
          const updatedBody = await updatedResponse?.json();
          const centreStore = useCenterStore();
          centreStore.datas = updatedBody.payload;
        }
      }
    }
  });
}

//m�thode 2 : par convention de nommage
//// Ca c'est pour etre g�n�rique, mais on peut faire du sp�cifique API par API on pourra �changer sur ce code la prochaine fois
//const CACHE_PREFIX = 'cache-api-'

//navigator.serviceWorker.addEventListener('message', async (event) => {
//    if (event.data.meta === 'workbox-broadcast-update') {
//        const { cacheName, updatedURL } = event.data.payload
//        if (cacheName.startsWith(CACHE_PREFIX)) {
//            const cache = await caches.open(cacheName)
//            const keys = await cache.keys()
//            const cachedRequest = keys.find(({ url }) => url === updatedURL)
//            if (cachedRequest) {
//                const storeName = cacheName.substring(CACHE_PREFIX.length)
//                const piniaStore = Pinia._s.get(storeName) //_s => liste des stores. (ne pas tenir compte du _s soulign� (si pas ))
//                const updatedResponse = await cache.match(cachedRequest)
//                const updatedBody = await updatedResponse?.json()
//                if (piniaStore) {

//                    // reloadFromCache est une action (synchrone) impl�ment�e par les store pinia pouvant etre mis � jour de cette mani�re
//                    piniaStore.reloadFromCache(updatedBody.payload)
//                }
//            }
//        }
//    }
//})
